import { render, staticRenderFns } from "./Director.vue?vue&type=template&id=1ada0843"
import script from "./Director.vue?vue&type=script&lang=js"
export * from "./Director.vue?vue&type=script&lang=js"
import style0 from "./Director.vue?vue&type=style&index=0&id=1ada0843&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports